import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { useExpensesByCategory } from '../../hooks/useApi';

ChartJS.register(ArcElement, Tooltip, Legend);

const CategoryChart = ({ account }) => {
  const { data, loading } = useExpensesByCategory(account);
  if (loading) return <div>Chargement...</div>;

  const chartData = {
    labels: data.map((item) => item.categoryParent),
    datasets: [
      {
        data: data.map((item) => Math.abs(item.total)),
        backgroundColor: [
          '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40',
        ],
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
      },
    },
  };

  return (
    <div className="chart-container">
      <h3>Dépenses par catégorie</h3>
      <Pie data={chartData} options={options} />
    </div>
  );
};

export default CategoryChart;
